import React from "react";
import "./BotCard.css"

function BotCard({ bot, onDeleteBot }) {
    return (
        <div className="bot-card">
        <button className="delete-button" onClick={() => onDeleteBot(bot.id)}>❌</button>
        <img src={bot.avatar_url} alt={bot.name} />
        <h3 className="name">{bot.name}</h3>     
        <p className="bot-class">{bot.bot_class}</p>
        <div className="stats">
            <span>❤️ {bot.health}</span>
            <span>⚔️ {bot.damage}</span>
            <span>🛡️ {bot.armor}</span>
        </div>
        <p className="catchphrase">{bot.catchphrase}</p>
        </div>
    )
}

export default BotCard;